import TicketCloseForm from '../TicketCloseForm';

interface TicketCloseProps {
    setBlockScreen: (p: boolean) => void
    ticket_number: any
}

const TicketClose: React.FC<TicketCloseProps> = ({ setBlockScreen, ticket_number }) => {
    return (
        <TicketCloseForm
            setBlockScreen={setBlockScreen}
            ticket_number={ticket_number}
            action="create"
        />)
}

export default TicketClose